<template>
  <main class="image-attachment">
    <img v-if="preview" :src="preview" class="image-preview thumbnail" />

    <section>
      <div v-if="!preview" class="upload-photo" @click="clickedUpload" data-cy="add-photo-button">
        <span>add</span>

        <svg viewBox="0 0 100 90" class="sb-icon">
          <use xlink:href="#camera-icon"></use>
        </svg>

        <span>photo</span>
      </div>
    </section>

    <input
      accept="image/png,image/gif,image/jpeg"
      class="hide"
      ref="file-dialog"
      type="file"
      data-cy="photo-upload-input"
      @change="fileChanged" />
  </main>
</template>

<script>
export default {
  name: "image-attachment",
  props: {
    preview: String
  },
  computed: {
    fileDialog() {
      return this.$refs['file-dialog'];
    }
  },
  methods: {
    clickedUpload() {
      this.fileDialog.click();
    },
    fileChanged() {
      if(this.fileDialog.files.length > 0) {
        this.$emit('updated:file', this.fileDialog.files[0])
      }
    }
  }
}
</script>

<style scoped>
  img.image-preview {
    border: none;
    margin-bottom: 0px;
    height: 100px;
  }

  .upload-photo {
    padding: 10px 0;
    width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;

    cursor: pointer;
    color: #4a4a4a;
  }

  .sb-icon {
    width: 36px;
    fill: #128ff9;
    margin: 5px 0;
  }
</style>
